// extracted by mini-css-extract-plugin
export default {"location":"style_location__na0VA","rate-face":"style_rate-face__kXqD9"};